import { Injectable } from '@angular/core';
import * as moment from 'moment';


@Injectable()
export class ElapsedTimeService  {

  constructor() {}

  getDisplayElapsedTime(timeStamp:string):string{
    const curTime = new Date().getTime();
    const timeStampInMili = moment(timeStamp).valueOf() ;
    let delta =  Math.abs(curTime - timeStampInMili) / 1000;

    // calculate (and subtract) whole days
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // calculate seconds
    var seconds = Math.round(delta % 60);  

    const displayList = [];
    const dayLabel = `${days} days ago`;
    const hourLabel = `${hours} hours ago`;
    const minuteLabel = `${minutes} minutes ago`;
    const secondLabel = `${seconds} seconds ago`;
    
    if(days > 0){
      return dayLabel;
    } else if(hours > 0){
      return hourLabel;
    }else if(minutes > 0){
      return minuteLabel;
    }else{
      return secondLabel;
    }
  }

}